import styles from "./Loader.module.scss";

const Loader = ({
  size = 24,
  borderWidth = 2,
}: {
  size?: number;
  borderWidth?: number;
}) => {
  return (
    <div
      className={styles["comp"]}
      style={{
        borderWidth: `${borderWidth}px`,
        width: `${size}px`,
        height: `${size}px`,
      }}
    />
  );
};

export { Loader };
